module.exports = __webpack_public_path__ + "static/icons/icon-webcam--black-56d9165179aea2246773644d9606242b.svg";